import { Backdrop, Box, Button, Fade, Modal, Typography } from "@mui/material";
import { useRef } from "react";
import { useFullscreen } from "../../../hooks/useFullscreen";

type Variant = "modal" | "popup";

interface Props {
  open: boolean;
  onClose: () => void;
  imageSrc: string;
  variant: Variant;
}

export const UnifiedImageModal = ({
  open,
  onClose,
  imageSrc,
  variant,
}: Props) => {
  const imageRef = useRef<HTMLElement>(null);
  const { isFullscreen, toggleFullscreen } = useFullscreen(imageRef);

  if (variant === "modal") {
    return (
      <Modal
        open={open}
        onClose={onClose}
        closeAfterTransition
        data-testid="el-modal"
        slots={{ backdrop: Backdrop }}
        slotProps={{ backdrop: { timeout: 500 } }}
      >
        <Fade in={open}>
          <Box
            data-testid="modal-backdrop"
            onClick={onClose}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100vh",
              bgcolor: "rgba(0,0,0,0.9)",
              zIndex: 1,
            }}
          >
            <Box
              onClick={(e) => e.stopPropagation()}
              sx={{
                cursor: "zoom-in",
                zIndex: 2,
              }}
            >
              <img
                alt="el-image"
                src={imageSrc}
                ref={imageRef as any}
                onClick={() => {
                  document.fullscreenElement
                    ? document.exitFullscreen()
                    : imageRef.current?.requestFullscreen();
                }}
                style={{
                  maxHeight: "90vh",
                  maxWidth: "90vw",
                  objectFit: "contain",
                  boxShadow: "0 0 10px white",
                }}
              />
            </Box>
          </Box>
        </Fade>
      </Modal>
    );
  }

  // variant === 'popup'
  return (
    <Box
      sx={{
        position: "fixed",
        top: 100,
        right: 50,
        maxWidth: 1000,
        backgroundColor: "white",
        boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
        border: "1px solid #ccc",
        zIndex: 1200,
        p: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      <Button
        variant="contained"
        color="error"
        sx={{
          position: "absolute",
          top: 10,
          right: 10,
          zIndex: 1300,
        }}
        onClick={onClose}
      >
        X
      </Button>

      <Typography variant="h6" sx={{ mb: 1 }}>
        EL Image (click to fullscreen):
      </Typography>
      <Box
        component="img"
        ref={imageRef}
        src={imageSrc}
        alt="EL Image"
        onClick={toggleFullscreen}
        data-testid={isFullscreen ? "fullscreen" : "el-image"}
        sx={{
          maxWidth: "100%",
          border: "1px solid #ccc",
          cursor: "pointer",
        }}
      />
    </Box>
  );
};
